module.exports = __webpack_public_path__ + "img/CC.985a76c5.svg";